import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css';
import Logo from "./components/login_page/logo";

function App() {
  const [ip, setIp] = useState('unknown');
  const [code, setCode] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  console.log("Version 0.0.6")
  let currentIp = '';

  const fetchIp = async () => {
    console.log("Fetching IP address...")
    try {
      const response = await axios.get('https://api.ipify.org?format=json');
      currentIp = response.data.ip;
      setIp(response.data.ip);
      console.log(response.data.ip)
    } catch (error) {
      console.error('Error fetching IP address:', error);
    }
  };

  useEffect(() => {
    fetchIp();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return; // Prevent multiple submissions

    setIsSubmitting(true);
    setResponseMessage("Checking current IP address")
    console.log("Sending data to backend")
    await fetchIp();
    console.log("IP address has been refreshed")
    console.log("IP which will be send to backend:" + currentIp)
    console.log("IP which could be send to backend:" + ip)
    setResponseMessage("Requesting access...")

    try {
      const response = await axios.post(
          'https://ct8wntusoh.execute-api.eu-west-1.amazonaws.com/v1/infra/ip-allow',
          {'ip': currentIp},
          {
            timeout: 30000,
            headers: {
              "Content-Type": "application/json",
              "x-api-key": `${code}`,
            },
          }
      );
      setResponseMessage(response.data);
      setIsSubmitting(false);
    } catch (error) {
      console.error('Error submitting code:', error);
      setResponseMessage('There was an error submitting your code.');
      setIsSubmitting(false);
    }
  };

  return (
      <div className="App">
        <header className="App-header">
          <Logo/>
          <h1>Token access</h1>
          <div className="app-owner">PSC Multicloud Platform</div>


          <p>Your IP address is: {ip}</p>
          <form onSubmit={handleSubmit}>
            <label>
              Enter your code:
              <input
                  type="text"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  maxLength="40"
                  size={40}
                  disabled={isSubmitting}
              />
            </label>
            <button type="submit" disabled={isSubmitting}>Submit</button>
          </form>
          <p>{responseMessage}</p>
        </header>
      </div>
  );
}

export default App;